export const TAG_KEYS = {
  site: 'site_served_tags' as TagKeys,
  universal: 'universal_tags' as TagKeys,
  bulk: 'bulk_tags' as TagKeys
};
